import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

function isIgnoredRuntimeError(message) {
  if (typeof message !== 'string') {
    return false;
  }
  return message.includes('ResizeObserver loop')
    || /timeout of \d+ms exceeded/i.test(message);
}

function ignoreRuntimeEvent(event, message) {
  if (!isIgnoredRuntimeError(message)) {
    return;
  }
  event.stopImmediatePropagation();
  event.preventDefault();
}

// Capture phase so this runs before CRA/webpack overlay handlers.
window.addEventListener(
  'error',
  (event) => {
    ignoreRuntimeEvent(event, event?.message || event?.error?.message);
  },
  true
);

window.addEventListener(
  'unhandledrejection',
  (event) => {
    ignoreRuntimeEvent(event, event?.reason?.message || String(event?.reason || ''));
  },
  true
);

// Defer ResizeObserver callbacks to avoid the loop warning from Ant Table / charts.
if (typeof window.ResizeObserver !== 'undefined') {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
